import React from "react";
import Icon from "../Icon";

function CircularProgress() {
    return <Icon name="loading" size="xxlg" className="loading" color="secondary" />;
}

export default CircularProgress;
